// src/pages/Trade.js 
// (Assuming this file contains your Trade component, which handles the Find Dealer page)

import React from 'react';
import { Helmet } from 'react-helmet-async'; // 👈 Import the Helmet component

// Common Components
import Navbar from '../../CommonComponent/Navbar/Navbar'; // Importing the Navbar component
import Footer from '../../CommonComponent/Footer/footer';
import NotificationBar from '../../CommonComponent/Notification/NotificationBar';

// Page Component
import BecomeADealer from './PageComponent/become-a-dealer';

function Trade() {

    // The useMeta hook call is removed and its content is moved into <Helmet>
    return (
        <>
            <Helmet>
                {/* Primary SEO Tags */}
                <title>Find Dealer | Marvel Blinds</title>
                <meta
                    name="description"
                    content="find a nearby showroom in your city."
                />
                <link rel="canonical" href={`${process.env.REACT_APP_WEBSITE_URL}/find-dealer`} />

                {/* Open Graph Tags (for Social Media) */}
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="article" />
                <meta property="og:title" content="Find Dealer" />
                <meta
                    property="og:description"
                    content="find a nearby showroom in your city."
                />
                <meta property="og:url" content={`${process.env.REACT_APP_WEBSITE_URL}/find-dealer`} />
                <meta property="og:site_name" content="Marvel Blinds" />
            </Helmet>

            {/* Rest of your component structure */}
            <div>
                <Navbar />
                <NotificationBar />
                <BecomeADealer />
                <Footer />
            </div>
        </>
    );
}

export default Trade;